import React, { useState, useEffect, useRef } from "react";
import { TextField, Box, Typography, Avatar, Grid } from "@mui/material";
import Logo from "../../image/boozLogo.png";
import CommonDialog from "../notification/ErrorDialogbox";
import { useDispatch, useSelector } from "react-redux";
import {
  verifyOtpRequest,
  requestOtpRequest,
} from "../../redux/auth/AuthAction";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import CustomButton from "../constant/commonButton";
import CryptoJS from "crypto-js";
import { APP_LINK } from "../global/MenuItems";
import { APP_LINKS } from "../global/wholeSalerMenuItems";

const OTPVerifyRegister = () => {
  const { handleSubmit, setValue } = useForm();
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [countdown, setCountdown] = useState(45);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [otpError, setOtpError] = useState("");
  const [loading, setLoading] = useState(false);
  const [decryptedEmail, setDecryptedEmail] = useState("");

  const otpRequested = useRef(false);
  const firstInputRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const otpDetails = useSelector((state) => state?.auth?.registerOtp) || {};

  const SECRET_KEY = "843567893696976453275974432697R634976";

  const decryptData = (encryptedData) => {
    if (!encryptedData) return "";
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
      const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

      if (!decryptedText) {
        console.error("Decryption returned empty string.");
      }

      return decryptedText;
    } catch (error) {
      console.error("Decryption failed:", error);
      return "";
    }
  };

  useEffect(() => {
    if (!otpRequested.current) {
      const encryptedEmail = localStorage.getItem("email");
      if (encryptedEmail) {
        const email = decryptData(encryptedEmail);
        setDecryptedEmail(email);
        const formData = { email: email, subject_type: "1" };
        dispatch(requestOtpRequest(formData));
        otpRequested.current = true;
      }
    }
  }, [dispatch]);

  useEffect(() => {
    let timer;
    if (isResendDisabled && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    }
    if (countdown === 0) {
      setIsResendDisabled(false);
    }
    return () => clearInterval(timer);
  }, [isResendDisabled, countdown]);

  useEffect(() => {
    if (firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, []);

  const handleChange = (e, index) => {
    const value = e?.target?.value;
    if (/^[0-9]*$/.test(value) && value?.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      setValue(`verification_code[${index}]`, value);
      if (value && index < otp?.length - 1) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e?.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  const onSubmit = async (data) => {
    const encryptedEmail = localStorage.getItem("email");
    const email = decryptData(encryptedEmail);

    if (!email) {
      console.error("Decryption failed or email is missing.");
      return;
    }

    if (otp.some((digit) => digit === "") || otp.join("").length < 6) {
      setOtpError("OTP required");
      setTimeout(() => {
        setOtpError("");
      }, 3000);
      return;
    }

    const otpCode = otp.join("");
    const otpData = { email: email, verification_code: otpCode };

    setLoading(true);
    await dispatch(verifyOtpRequest(otpData));
    setLoading(false);
  };

  useEffect(() => {
    if (otpDetails?.success) {
      setDialogMessage("Email verified successfully. Please verify your mobile number.");
      setIsSuccess(true);
      setDialogOpen(true);
      setTimeout(() => {
        setDialogOpen(false);
        navigate(APP_LINKS.MOBILEOTPVERIFY)
      }, 3000);
    } else if (otpDetails?.error) {
      setDialogMessage("Enter the correct OTP");
      setDialogOpen(true);
      setIsSuccess(false);
      setTimeout(() => {
        setDialogOpen(false);
        setDialogMessage("");
      }, 3000);
    }
  }, [otpDetails, navigate]);

  const handleResendOtp = () => {
    setIsResendDisabled(true);

    const encryptedEmail = localStorage.getItem("email");
    const email = decryptData(encryptedEmail);
    const formData = { email: email, subject_type: "1" };

    setOtp(["", "", "", "", "", ""]);
    setOtpError("");
    setDialogMessage("");
    setDialogOpen(false);

    dispatch(requestOtpRequest(formData));
    setCountdown(45);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleBackToLogin = () => {
    navigate("/");
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Box
        elevation={3}
        sx={{ padding: 2, textAlign: "center", width: 500, height: 400 }}
      >
        <Grid item xs={12} align="center">
          <Avatar src={Logo} className="avatar" />
        </Grid>
        <Typography variant="h6">Enter OTP</Typography>
        {decryptedEmail && (
          <Typography
            variant="body2"
            sx={{
              marginBottom: 2,
              color: "#1976d2",
              fontWeight: 500,
            }}
          >
            OTP has been sent to{" "}
            <span style={{ fontWeight: "bold", color: "#d32f2f" }}>
              {decryptedEmail}
            </span>
          </Typography>
        )}

        <Box
          sx={{ display: "flex", justifyContent: "center", marginBottom: 2 }}
        >
          {otp?.map((digit, index) => (
            <TextField
              key={index}
              inputRef={index === 0 ? firstInputRef : null}
              id={`otp-input-${index}`}
              name={`verification_code[${index}]`}
              value={digit}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              inputProps={{ maxLength: 1 }}
              sx={{
                width: "50px",
                height: "50px",
                textAlign: "center",
                margin: "0 5px",
              }}
            />
          ))}
        </Box>
        {otpError && (
          <Typography variant="body2" color="error">
            {otpError}
          </Typography>
        )}
        <Box
          sx={{
            display: "flex",
            gap: "10px",
            width: "100%",
            paddingTop: "10px",
            paddingLeft: "40px",
            paddingRight: "40px",
            justifyContent: "center",
          }}
        >
          <CustomButton
            text="Submit"
            size="large"
            type="submit"
            buttonStyle="SubmitButton1"
            variant="contained"
            onClick={handleSubmit(onSubmit)}
            disabled={loading || otpDetails?.inProgress}
            loading={loading || otpDetails?.inProgress}
          ></CustomButton>
          <CustomButton
            variant="outlined"
            onClick={handleResendOtp}
            buttonStyle="style1"
            disabled={isResendDisabled}
            sx={{
              color: isResendDisabled ? "red" : "inherit",
            }}
          >
            {isResendDisabled ? `Resend OTP in ${countdown}s` : "Resend OTP"}
          </CustomButton>
        </Box>
        <Box>
          <CustomButton
            variant="text"
            onClick={handleBackToLogin}
            sx={{ textDecoration: "none", color: "inherit" }}
          >
            Back to Login
          </CustomButton>
        </Box>

        {/* Dialog */}
        <CommonDialog
          open={dialogOpen}
          isSuccess={isSuccess}
          onClose={handleDialogClose}
          messageSuccess={dialogMessage}
          messageError={dialogMessage}
        />
      </Box>
    </Box>
  );
};

export default OTPVerifyRegister;
